import { ButtonPropsContext } from './ButtonCore';
import { Theme } from '@emotion/react';
import { Typography } from 'omakase';
import { buttonDynamicContent } from './buttonCssDefs';
import React, { useContext } from 'react';

interface ButtonDynamicContentProps {
  /**
   * value if children is empty, styled as placeholder
   */
  placeholder: string;
}

/**
 * ButtonDynamicContent describes content that goes inside of a Button
 * but can default to placeholder text if not present.
 *
 * Also, if there are more than one ButtonDynamicContent children of a Button,
 * They received spacing and borders between them.
 */
const ButtonDynamicContent: React.FC<ButtonDynamicContentProps> = ({ children, placeholder }) => {
  const hasChildren = Boolean(children);
  const { disabled } = useContext(ButtonPropsContext);
  return (
    <Typography
      component="span"
      css={(theme: Theme) => buttonDynamicContent(theme, Boolean(disabled), hasChildren)}
      variant={hasChildren ? 'body02Strong' : 'body02'}
    >
      {hasChildren ? children : placeholder}
    </Typography>
  );
};

export default ButtonDynamicContent;
